window.__pt = window.__pt || {};
window.__pt.ln = window.__pt.ln || {};
window.__pt.settings = window.__pt.settings || {};

/** Dates */
window.__pt.settings.formatBoxDate = "MMM D, YYYY";
window.__pt.settings.formatBoxDateMobile = "MMM D";
window.__pt.settings.formatDate = "yyyy-MM-dd";
window.__pt.settings.formatMomentDate = "YYYY-MM-DD";
window.__pt.settings.formatDateSlash = "MMM dd, yyyy";

window.__pt.ln = {
    and: "and",
    continue: 'Continue',
    total: "Total",
    nights: "nights",
    night: "night",
    nightm: "night",
    nighstm: "nights",
    person: "person",
    persons: "people",
    pay: 'Book now',
    adult: 'adult',
    adults: 'adults',
    persons: 'people',
    person: 'person',
    child: 'child',
    children: 'children',
    the: 'from',
    years: 'years',
    year: 'year',
    minore: 'child',
    minores: 'children',
    room: 'room',
    rooms: 'rooms',
    selecteds: "selected",
    selected: "selected",
    for: "for",
    fora: "by",
    free: 'Free',
    locale_lang: "es",
    locale: 'es-es',
    loading: 'loading..',
    ok: 'Accept',
    cancel: 'Cancel',
    capacity: 'Sleeps {0}',
    kidsFreeTo: 'from 0 to {0} years',
    rating: {
        "10": "Excellent",
        "9": "Outstanding",
        "8": "Very good",
        "7": "Good",
        "default": "Convenient",
    },
    rating_reviews_range: [
        {
            "display": "Exceptional",
            "range": [9.6, 10.0]
        },
        {
            "display": "Wonderful",
            "range": [9.0, 9.5]
        },
        {
            "display": "Excellent",
            "range": [8.6, 8.9]
        },
        {
            "display": "Very Good",
            "range": [8.0, 8.5]
        },
        {
            "display": "Good",
            "range": [7.0, 7.9]
        },
        {
            "display": "Aceptable",
            "range": [6.0, 6.9]
        },
        {
            "display": "Bad",
            "range": [0.1, 5.9]
        }
    ],
    rating_reviews: {
        "1": "Terrible",
        "2": "Poor",
        "3": "Okay",
        "4": "Good",
        "5": "Excellent",
    },
    promotions_keys: {
        "106": "Midweek offer",
        "96": "Hot Sale",
        "115": "Oferta Buen Fin"
    },
    hotel_lang: "Hotel",
    flight_round: "Flight Round",
    flight_one_way: "Flight One Way",
    package_lang: "Hotel + Flight",
    new_room: "Rm.",
    new_pers: "pers.",
    price_calendar_footer: "Approximate prices in {currency} for a 1-night stay to 2 adults"
};

window.__pt.ln.availabilityMessages = {
    "minimumstay": {
        "title1": "Rooms with minimum stay",
        "title2": "Try booking a minimum of {{days}} nights"
    },
    "maximumstay": {
        "title1": "Rooms with maximum stay",
        "title2": "Try booking a maximum of {{days}} nights"
    },
    "none": {
        "title1": "Not available for the selected dates",
        "title2": "Try changing the dates or call toll free"
    },
    "peoplemax": {
        "title1": "Maximum guest capacity",
        "title2": "Try changing the number of people or rooms"
    },
    "adultsmax": {
        "title1": "You exceed the limit of adults per room",
        "title2": "Try changing the number of rooms"
    },
    "kidsmax": {
        "title1": "You exceed the limit of children per room",
        "title2": "Try changing the number of people or rooms"
    },
    "kidszero": {
        "title1": "You exceed the limit of children per room",
        "title2": "Try selecting adults only"
    },
    "defaults": { "minimumstay": 5, "maximumstay": 30 }
};

window.__pt.ln.mealplans = {
    "A": "American breakfast",
    "AA": "Imperial Christmas and New Years Eve",
    "AB": "Romantic Getaway",
    "AC": "Romantic Getaway and Spa",
    "AD": "Lunch and dinner with drinks",
    "AE": "Breakfast (adults only)",
    "AF": "Gourmet American Breakfast",
    "AG": "Breakfast for 2",
    "AH": "Continental Breakfast for 2",
    "AI": "Breakfast & lunch",
    "AJ": "Breakfast, lunch, dinner with liquids",
    "AK": "Semi All Inclusive",
    "AL": "3 meals + 2 snacks",
    "AM": "Dining Plan",
    "AN": "Quick Service",
    "AO": "Breakfast, lunch or dinner included, beverages not included",
    "AP": "Breakfast, snack & dinner included",
    "AQ": "Breakfast, lunch or dinner included",
    "AR": "Non Refundable",
    "AS": "Drinks Included",
    "AT": "Breakfast, lunch, and dinner available only for adults",
    "AU": "Continental breakfast adults only",
    "AV": "Breakfast – nonrefundable",
    "AW": "Food, Beverages and Tours included",
    "AX": "Breakfas for 1 adult",
    "AY": "Dinner",
    "AZ": "All Inclusive",
    "B": "Buffet breakfast",
    "BA": "Premium",
    "C": "Lunch",
    "E": "Room Only",
    "F": "Breakfast & dinner included",
    "G": "Breakfast, lunch & dinner included",
    "H": "Breakfast, lunch or dinner included",
    "I": "All Inclusive",
    "J": "Continental breakfast buffet",
    "K": "All Inclusive",
    "L": "Breakfast",
    "M": "Breakfast & dinner with beberages",
    "N": "Breakfast without beverages",
    "O": "Open Bar",
    "P": "Breakfast & dinner, no drinks",
    "Q": "Breakfast, lunch & dinner, no drinks",
    "R": "Buffet breakfast, no beverages",
    "S": "Breakfast and lunch or dinner, beverages not included",
    "T": "Lunch without beverages",
    "U": "2 quick service meals + 1 snack",
    "V": "2 meals + 1 snack",
    "W": "3 meals, no beverages",
    "X": "Dinner without beverages",
    "Y": "Continental breakfast without beverages",
    "Z": "Continental breakfast",
    "ZA": "American breakfast - Non Refundable",
    "ZR": "Continental breakfast - Non Refundable",
    "BZ": "Buffet breakfast - Non Refundable",
    "GR": "Breakfast, lunch & dinner included - Non Refundable",
    "PR": "Breakfast and Dinner - Non Refundable"
};

window.__pt.ln.freecancellation = {
    "notallowed": "No refund",
    "allowed": "Free cancellation",
};

window.__pt.ln.promotion = {
    "40%dedescuento+2niñosgratis": "40% of discount + 2 children free",
    "ventaespecial": "Special Sale",
    "60%dedescuento": "Promotion 60% discount",
    "30%dedescuento": "Promotion 30% discount",
    "ofertadeverano": "Summer Sale",
    "20-30": "20% discount",
    "30-40": "30% discount",
    "40-50": "40% discount",
    "50-100": "Up to 50% discount"
};
window.__pt.ln.paymentmethods = {
    "2": "Pay at property"
}
window.__pt.ln.stars = {
    "5": "5 stars",
    "4": "4 stars",
    "3": "3 stars",
    "2": "2 stars",
    "1": "1 star"
};

window.__pt.ln.reviews = {
    "dwonderful": "Wonderful 9.0+",
    "bverygood": "Very Good 8.0+",
    "agood": "Good 7.0+"
};
window.__pt.ln.filterslang = {
    "zones": "zonas",
    "amenities": "amenidades",
    "room-view": "vista-de-la-habitacion",
    "interest": "interes"
};
window.angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
    $provide.value("$locale", {
        "DATETIME_FORMATS": {
            "AMPMS": [
                "a.m.",
                "p.m."
            ],
            "DAY": [
                "domingo",
                "lunes",
                "martes",
                "mi\u00e9rcoles",
                "jueves",
                "viernes",
                "s\u00e1bado"
            ],
            "ERANAMES": [
                "antes de Cristo",
                "despu\u00e9s de Cristo"
            ],
            "ERAS": [
                "a. C.",
                "d. C."
            ],
            "FIRSTDAYOFWEEK": 0,
            "MONTH": [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december"
            ],
            "SHORTDAY": [
                "Sun.",
                "Mon.",
                "Tues.",
                "Wed.",
                "Thurs.",
                "Fri.",
                "sat."
            ],
            "SHORTMONTH": [
                "Jan.",
                "Feb.",
                "Mar.",
                "Apr.",
                "May.",
                "Jun.",
                "Jul.",
                "Aug.",
                "Sept.",
                "Oct.",
                "Nov.",
                "Dec."
            ],
            "STANDALONEMONTH": [
                "january",
                "february",
                "march",
                "april",
                "may",
                "june",
                "july",
                "august",
                "september",
                "october",
                "november",
                "december"
            ],
            "WEEKENDRANGE": [
                5,
                6
            ],
            "fullDate": "EEEE, y 'de' MMMM 'de' d",
            "longDate": "y 'de' MMMM 'de' d",
            "medium": "y MMM d HH:mm:ss",
            "mediumDate": "y MMM d",
            "mediumTime": "HH:mm:ss",
            "short": "yy/M/d HH:mm",
            "shortDate": "yy/M/d",
            "shortTime": "HH:mm"
        },
        "NUMBER_FORMATS": {
            "CURRENCY_SYM": "$",
            "DECIMAL_SEP": ".",
            "GROUP_SEP": ",",
            "PATTERNS": [
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 3,
                    "minFrac": 0,
                    "minInt": 1,
                    "negPre": "-",
                    "negSuf": "",
                    "posPre": "",
                    "posSuf": ""
                },
                {
                    "gSize": 3,
                    "lgSize": 3,
                    "maxFrac": 2,
                    "minFrac": 2,
                    "minInt": 1,
                    "negPre": "-\u00a4",
                    "negSuf": "",
                    "posPre": "\u00a4",
                    "posSuf": ""
                }
            ]
        },
        "id": "en",
        "localeID": "en",
        "pluralCat": function (n, opt_precision) { if (n == 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
    });
}]);


window.__pt.settings.loginErrors = {
    "auth/account-exists-with-different-credential": "The email is already in use with different credentials",
    "auth/email-already-in-use": "The email is already in use",
    "auth/invalid-email": "Invalid email",
    "auth/operation-not-allowed": "The operation is not allowed",
    "auth/weak-password": "Very weak password",
    "auth/auth-domain-config-required": "Unauthorized provider",
    "auth/cancelled-popup-request": "Login has been canceled",
    "auth/operation-not-supported-in-this-environment": "Operation not supported for this environment",
    "auth/user-disabled": "Disabled user",
    "auth/user-not-found": "User not found",
    "auth/wrong-password": "Your password is incorrect",
    "auth/too-many-requests": "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later."
}

window.__pt.ln.overriteTitles = {
    "Amenidades": "Instalaciones y servicios"
}